import React from "react";
import { Container, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MenuRoutes from "../../routing/menu_routes";
import { useTranslation } from "react-i18next";
import { Link, useMatch } from "react-router";
import AccessControlGuard from "shared/guards/accesscontrol.guard";
import { MenuArea, LinkWrapper } from "./menu.style";

interface ActivatableNavLinkProps {
  to: string;
  hasPendingChanges: boolean;
  children: React.ReactNode;
}

const ActivatableNavLink: React.FC<ActivatableNavLinkProps> = (props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { to, hasPendingChanges, children } = props;
  const match = useMatch(to + "/*");

  return (
    <LinkWrapper>
      <Link
        to={to}
        style={{
          color: match
            ? theme.custom.colors.mediMagenta
            : theme.custom.colors.mediGray,
          borderBottom: match
            ? `2px solid ${theme.custom.colors.mediMagenta}`
            : "none",
          paddingBottom: "13px",
        }}
        onClick={(event) => {
          let doLeave = true;
          if (hasPendingChanges)
            doLeave = window.confirm(t("LeavePageUnsavedChangesMessage"));

          if (!doLeave) event.preventDefault();

          return doLeave;
        }}
      >
        {children}
      </Link>
    </LinkWrapper>
  );
};

export const MenuComponent = () => {
  const { t } = useTranslation();

  return (
    <MenuArea>
      <Container>
        <Stack direction="row" alignItems="center">
          {MenuRoutes.map((entry) => (
            <AccessControlGuard
              key={t(entry.name) as React.Key}
              allowedRoles={entry.allowedRoles}
            >
              <ActivatableNavLink
                key={t(entry.name) as React.Key}
                to={entry.target}
                hasPendingChanges={false}
              >
                {t(entry.name)}
              </ActivatableNavLink>
            </AccessControlGuard>
          ))}
        </Stack>
      </Container>
    </MenuArea>
  );
};
